import { Settings } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { SettingsRoutes } from "./routes";
import { SettingsPermissions } from "./permissions";
import { ProviderRoutes } from "../providers/routes";
import { ProviderPermissions } from "../providers/permissions";
import { IssueSupportTemplateRoutes } from "../issue-support-templates/routes";
import { IssueSupportTemplatePermissions } from "../issue-support-templates/permissions";
import { SupportRoutes } from "../support/routes";
import { EmailTemplateRoutes } from "../email-templates/routes";
import { AirlinePermissions, EmailTemplatePermissions } from "../email-templates/permissions";
import { SupportPermissions } from "../support/permissions";
import { TourCatalogRoutes } from "../tour-catalog/routes";
import { TourCatalogPermissions } from "../tour-catalog/permissions";

export const settingsNav: INavItem = {
  labelKey: "nav.settings",
  icon: Settings,
  path: SettingsRoutes.INDEX,
  permissions: [SettingsPermissions.READ],
  permissionPrefix: "Travel:Settings:",
  children: [
    {
      labelKey: "nav.settings_general",
      path: SettingsRoutes.INDEX,
      permissions: [SettingsPermissions.READ],
    },
    {
      labelKey: "nav.settings_users",
      path: SettingsRoutes.USERS,
      permissions: [SettingsPermissions.USERS],
    },
    {
      labelKey: "nav.providers",
      path: ProviderRoutes.LIST,
      permissions: [ProviderPermissions.READ],
    },
    {
      labelKey: "nav.tour_catalog",
      path: TourCatalogRoutes.INDEX,
      permissions: [TourCatalogPermissions.READ],
    },
    {
      labelKey: "nav.issue_support_templates",
      path: IssueSupportTemplateRoutes.LIST,
      permissions: [IssueSupportTemplatePermissions.READ],
    },
    {
      labelKey: "nav.airlines",
      path: EmailTemplateRoutes.AIRLINES,
      permissions: [AirlinePermissions.READ],
    },
    {
      labelKey: "nav.email_brand",
      path: EmailTemplateRoutes.BRAND,
      permissions: [EmailTemplatePermissions.READ],
    },
    {
      labelKey: "nav.support_tickets",
      path: SupportRoutes.LIST,
      permissions: [SupportPermissions.READ],
    },
  ],
};
